import { format } from 'date-fns'

export const formatDateToTimestampz = (date: Date) => {
  // Usando o formato desejado: "yyyy-MM-dd HH:mm:ss.SSS Z"
  return format(date, "yyyy-MM-dd HH:mm:ss.SSS XXX");
} 